import { Suspense } from 'react';

import { RouterProvider } from 'react-router';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import ApplicationProvider from '@/context/application/application.provider';

import { useRouterConfiguration } from './hooks/router-configuration.hook';

const AppRouter = () => {
  const { devToolButtonPosition, devToolPosition, queryClient, ReactQueryDevtoolsProduction, router, showDevtools } =
    useRouterConfiguration();

  return (
    <ApplicationProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ReactQueryDevtools
          buttonPosition={devToolButtonPosition}
          initialIsOpen={false}
          position={devToolPosition}
        />
        {showDevtools && (
          <Suspense fallback={null}>
            <ReactQueryDevtoolsProduction />
          </Suspense>
        )}
      </QueryClientProvider>
    </ApplicationProvider>
  );
};

export default AppRouter;
